<template>
  <ul class="flex flex-col gap-12">
    <li>
      <RevLink
        class="flex items-center gap-8 no-underline"
        @click="onPaypayClick"
      >
        <RevIllustration
          alt=""
          class="shrink-0"
          :height="16"
          sizes="16px"
          src="/img/product/jp/points-paypay.svg"
          :width="16"
        />
        <FormattedMessage class="body-2" :definition="translations.paypay">
          <template #points>
            <span class="body-2-bold">
              {{ i18n(translations.points, { points: paypayPoints }) }}
            </span>
          </template>
        </FormattedMessage>

        <IconChevronRight class="shrink-0" size="16" />
      </RevLink>
      <PaypayModal
        :points="i18n(translations.points, { points: paypayPoints })"
      />
    </li>
    <li v-if="!onlyPaypay">
      <RevLink
        class="flex items-center gap-8 no-underline"
        href="https://www.backmarket.co.jp/ja-jp/service/rakuten-mobile"
        target="_blank"
        @click="onRakutenClick"
      >
        <RevIllustration
          alt=""
          class="shrink-0"
          :height="16"
          sizes="16px"
          src="/img/product/jp/points-rakuten.svg"
          :width="16"
        />
        <FormattedMessage class="body-2" :definition="translations.rakuten">
          <template #points>
            <span class="body-2-bold">
              {{ i18n(translations.points, { points: RAKUTEN_POINTS }) }}
            </span>
          </template>
        </FormattedMessage>
        <IconExternalLink class="shrink-0" size="16" />
      </RevLink>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconExternalLink } from '@ds/icons/IconExternalLink'

import { MODAL_NAMES } from '../../Product-JP.constants'
import PaypayModal from '../PaypayModal/PaypayModal.vue'

import { RAKUTEN_POINTS } from './PointsSection.constants'
import translations from './PointsSection.translations'
import { calculatePaypayPoints } from './calculatePaypayPoints.util'

const props = defineProps<{ price: Price; onlyPaypay?: boolean }>()

const i18n = useI18n()
const { trackClick } = useTracking()

const paypayPoints = computed(() => {
  return calculatePaypayPoints(props.price.amount)
})

function onPaypayClick() {
  trackClick({ zone: 'pills_under_price', name: 'paypay_pill' })
  openModal(MODAL_NAMES.PAYPAY)
}

function onRakutenClick() {
  trackClick({ zone: 'pills_under_price', name: 'rakuten_pill' })
}
</script>
